import validate from "/opt/carify/website/node_modules/nuxt/dist/pages/runtime/validate.js";
import storybok_45visual_45redirect_45global from "/opt/carify/website/middleware/storybok-visual-redirect.global.js";
import user_45global from "/opt/carify/website/middleware/user.global.js";
import manifest_45route_45rule from "/opt/carify/website/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  storybok_45visual_45redirect_45global,
  user_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/carify/website/middleware/auth.js"),
  guest: () => import("/opt/carify/website/middleware/guest.js"),
  staff: () => import("/opt/carify/website/middleware/staff.js")
}